import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import { message } from 'antd';

class FleetGeofenceSummaryReportStore {
  fleetGeofenceSummary = [];

  total = 0;
  loading = false;
  rootStore;
  loadingData = false;
  pageSize = 0;

  constructor(rootStore) {
    makeObservable(this, {
      fleetGeofenceSummary: observable,
      pageSize: observable,
      total: observable,
      loading: observable,
      loadingData: observable,

      loadData: action,
      exportExcel: action,
      exportpdf: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    vehicleId,
    fromDate,
    toDate,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };
    var response = await postApi.getClient('report').post("/alert_report/fleetgeofenceSummary", postData);

    this.total = parseInt(response?.data?.data?.TotalCount);

    this.fleetGeofenceSummary = response?.data?.data?.fleetgeofencesummary;
    this.loading = false;
  }

  async exportExcel(getDta) {

    try {
      await postApi.getClient("report").post("/alert_report/fleetgeofenceSummary/download/excel", getDta, {
        responseType: "blob",
      });
      this.pythonReportMessage = true;

    } catch (error) {
      this.pythonReportErrorMessage = true;
      message.error("Failed to download the report. Please try again.");
    }


  }

  async exportpdf(getDta) {
    try {
      await postApi.getClient("report").post("/alert_report/fleetgeofenceSummary/download/pdf", getDta, {
        responseType: "blob",
      });
      this.pythonReportMessage = true;

    } catch (error) {
      this.pythonReportErrorMessage = true;
      message.error("Failed to download the report. Please try again.");
    }
  }
}
export default FleetGeofenceSummaryReportStore;
